<template>
  <div class="uni-titleHeader">
    <header>
      <div class="left">
        <em></em>
        <span>{{ text }}</span>
      </div>

      <slot name="right"></slot>
    </header>
  </div>
</template>

<script>
export default {
  name: "uni-titleHeader",
  props: {
    text: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .left {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
  }
  em {
    display: inline-block;
    height: 23px;
    width: 4px;
    @include bgColor("primary");
    margin-right: 18px;
  }
  span {
    font-size: 20px;
    color: rgba(52, 52, 52, 1);
    font-weight: 700;
  }
}
</style>
